<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.numberLvMvStations.title"
                [body]="{
                    value: kpi.numberLvMvStations,
                    precision: texts.numberLvMvStations.precision,
                }"
                [badge]="{
                    value: kpi.numberLvMvStationsEvolution,
                    suffix: texts.numberLvMvStations.badgeSuffix,
                    precision: texts.numberLvMvStations.badgePrecision,
                    style: kpi.numberLvMvStationsEvolution! > 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.numberLvMvStations.descriptionTitle"
                [descriptionContent]="texts.numberLvMvStations.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'numberLvMvStations')"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.numberLvMvTransformers.title"
                [body]="{
                    value: kpi.numberLvMvTransformers,
                    precision: texts.numberLvMvTransformers.precision,
                }"
                [badge]="{
                    value: kpi.numberLvMvTransformersEvolution,
                    suffix: texts.numberLvMvTransformers.badgeSuffix,
                    precision: texts.numberLvMvTransformers.badgePrecision,
                    style: kpi.numberLvMvTransformersEvolution! > 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.numberLvMvTransformers.descriptionTitle"
                [descriptionContent]="texts.numberLvMvTransformers.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'numberLvMvTransformers')"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.averageAgeStations.title"
                [body]="{
                    value: kpi.averageAgeStations,
                    precision: texts.averageAgeStations.precision,
                    suffix: texts.averageAgeStations.suffix,
                }"
                [badge]="{
                    value: kpi.averageAgeStationsEvolution,
                    suffix: texts.averageAgeStations.badgeSuffix,
                    precision: texts.averageAgeStations.badgePrecision,
                    style: kpi.averageAgeStationsEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.averageAgeStations.descriptionTitle"
                [descriptionContent]="texts.averageAgeStations.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'averageAgeStations')"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.averageAgeTransformers.title"
                [body]="{
                    value: kpi.averageAgeTransformers,
                    precision: texts.averageAgeTransformers.precision,
                    suffix: texts.averageAgeTransformers.suffix,
                }"
                [badge]="{
                    value: kpi.averageAgeTransformersEvolution,
                    suffix: texts.averageAgeTransformers.badgeSuffix,
                    precision: texts.averageAgeTransformers.badgePrecision,
                    style: kpi.averageAgeTransformersEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.averageAgeTransformers.descriptionTitle"
                [descriptionContent]="texts.averageAgeTransformers.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'averageAgeTransformers')"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <chart-card
        id="lvMvEvolutionStationsChart"
        [title]="substationsChartTitle"
        [error]="substationsChartError"
        [isLoading]="!substationsChartData()[0].organizationId"
        [series]="substationsChartSeries"
        [dataLabels]="substationsDataLabels"
        [stacked]="true"
        [yaxis]="substationsYaxis"
        [precision]="texts.lvMvEvolutionStationsChart.precision"
        [xaxisTitle]="texts.lvMvEvolutionStationsChart.xaxisTitle"
        [legend]="substationsLegend"
        [customTooltip]="substationsCustomTooltip"
        class="h-100">
    </chart-card>

    <div class="row g-3">
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="transformersGenerationChart"
                [title]="transformersGenerationChartTitle"
                [error]="transformersGenerationChartError"
                [isLoading]="!transformersGenerationChartData()[0].organizationId"
                [series]="transformersGenerationChartSeries"
                [dataLabels]="transformersGenerationDataLabels"
                [stacked]="true"
                [yaxis]="transformersGenerationYaxis"
                [xaxisTitle]="texts.transformersGenerationChart.xaxisTitle"
                [legend]="transformersGenerationLegend"
                [customTooltip]="transformersGenerationCustomTooltip"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="highCabinsChart"
                [title]="highCabinsChartTitle"
                [error]="highCabinsChartError"
                [isLoading]="!highCabinsChartData()[0].organizationId"
                [series]="highCabinsChartSeries"
                [dataLabels]="highCabinsDataLabels"
                [stacked]="true"
                [yaxis]="highCabinsYaxis"
                [xaxisTitle]="texts.highCabinsChart.xaxisTitle"
                [legend]="highCabinsLegend"
                [customTooltip]="highCabinsCustomTooltip"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="transformersMeanAgeChart"
                [title]="transformersMeanAgeChartTitle"
                [error]="transformersMeanAgeChartError"
                [isLoading]="!transformersMeanAgeChartData()[0].organizationId"
                [series]="transformersMeanAgeChartSeries"
                [dataLabels]="transformersMeanAgeDataLabels"
                [stacked]="false"
                [yaxis]="transformersMeanAgeYaxis"
                [grid]="transformersMeanAgeGrid"
                [xaxisTitle]="texts.transformersMeanAgeChart.xaxisTitle"
                [unitTooltip]="texts.transformersMeanAgeChart.unitTooltip"
                [precision]="texts.transformersMeanAgeChart.precision"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="urbanRuralSubstationsChart"
                [title]="urbanRuralSubstationsChartTitle"
                [error]="urbanRuralSubstationsChartError"
                [isLoading]="!urbanRuralSubstationsChartData()[0].organizationId"
                [series]="urbanRuralSubstationsChartSeries"
                [dataLabels]="urbanRuralSubstationsDataLabels"
                [labels]="urbanRuralSubstationsLabels"
                [colors]="urbanRuralSubstationsColors"
                type="pie"
                [fill]="{ opacity: 0.9 }"
                cardClass="h-100"></chart-card>
        </div>
    </div>
</div>
